import React from "react";
import { withTranslation } from "react-i18next";
import "./GetStarted.scss";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Link } from "react-router-dom";
import HomeFooter from "components/Home-Footer";
import { useAppContext } from "context/AppContext";

function GetStarted({ t }) {
  const { signupHandler } = useAppContext();

  const moveToSignUp = () => {
    signupHandler(window.location.pathname);
  };

  return (
    <div className="app-page">
      <div className="banner-block  get-started-banner">
        <div className="container">
          <div className="get-started-header">
            <div className="row">
              <div className="col-lg-12">
                <div className="getstarted-logo">
                  <Link to="/">
                    <div className="logo">
                      <img
                        src={require("assets/images/home-logo.svg").default}
                        alt="img"
                        className="img-fluid"
                      />
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="banner-caption">
            <h2>{t("getstarted.getstarted")}</h2>
            <p>{t("getstarted.getstartedDesc")}</p>
            <Nav tabs className="get-started-tabs">
              <NavItem>
                <a
                  href="https://meetings.hubspot.com/madjid-rassamanesh/miraxis-demo-meeting"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link text-decoration-none"
                >
                  <img
                    className="icon-grey"
                    src={
                      require("assets/images/landing-pages/request-demo-icon.svg")
                        .default
                    }
                    alt="icon"
                  />
                  {t("getstarted.bookDemo")}
                </a>
              </NavItem>
              <NavItem>
                <NavLink onClick={moveToSignUp}>
                  <img
                    className="icon-grey"
                    src={
                      require("assets/images/landing-pages/signup-icon.svg")
                        .default
                    }
                    alt="icon"
                  />

                  {t("getstarted.startFreeTrial")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
}
export default withTranslation()(GetStarted);
